import type { WidgetProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const RadioWidget = ({
  disabled,
  id,
  onChange,
  options,
  readonly,
  required,
  uiSchema,
  value: checked
}: WidgetProps) => {
  const Tag = uiSchema?.['ui:stacked'] === true ? Mtds.Grid : Mtds.Flex

  return (
    <Tag data-gap='5'>
      {options.enumOptions?.map(({ label, value }, index) => (
        <Mtds.Field
          as='input'
          checked={checked != null && `${checked}` === `${value}`}
          disabled={disabled}
          id={`${id}_${index}`}
          key={value}
          label={label}
          onChange={() => onChange(value)}
          readOnly={readonly}
          required={required}
          type='radio'
          value={value}
        />
      ))}
    </Tag>
  )
}
